import React from 'react'

type HtmlProps = {
  input: string
}

export default function Html(props: HtmlProps) {
  return <div dangerouslySetInnerHTML={{ __html: props.input }}></div>
}
